/**
 * @jsxRuntime classic
 * @jsx jsx
 */
/** @jsxFrag */
import React from 'react';

// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { css, jsx } from '@emotion/react';
import { useIntl } from 'react-intl-next';
import { SimpleTag } from '@atlaskit/tag';
import { messages } from './messages';

/**
 * The opacity of this button is controlled by the parent component
 */
var containerStyles = css({
  flexShrink: 0,
  marginLeft: 'auto',
  marginTop: "var(--ds-space-negative-025, -2px)",
  marginBottom: "var(--ds-space-negative-025, -2px)",
  display: 'inline-flex',
  opacity: 0,
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
  '& > span': {
    cursor: 'pointer',
    margin: 0,
    padding: "var(--ds-space-025, 2px)".concat(" ", "var(--ds-space-075, 6px)")
  }
});
var placeholderStyles = css({
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
  '& > span': {
    cursor: 'default'
  }
});
export var EditPromptHoverTag = function EditPromptHoverTag(_ref) {
  var _ref$isClearMode = _ref.isClearMode,
    isClearMode = _ref$isClearMode === void 0 ? false : _ref$isClearMode,
    isPlaceholder = _ref.isPlaceholder;
  var _useIntl = useIntl(),
    formatMessage = _useIntl.formatMessage;
  var text = React.useMemo(function () {
    return isClearMode ? formatMessage(messages.clearPromptHover) : formatMessage(messages.editPromptHover);
  }, [isClearMode, formatMessage]);
  return jsx("span", {
    id: "edit-prompt-hover-button",
    "data-testid": "edit-prompt-hover-button",
    css: [containerStyles, isPlaceholder && placeholderStyles]
  }, jsx(SimpleTag, {
    text: text
  }));
};